import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ConfirmCodeForm, SignUpComplete, SignUpFormFields } from '../components/SignUpForm';
import { useSignUp } from '../hooks/use-sign-up';

/**
 * Webサインアップページ
 *
 * ダウンロードページにアクセスするための新規アカウント作成ページ
 * サインアップ完了後はWebログインページへリダイレクト
 */
export function WebSignUpPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirect') ?? '/download';

  const navigateToLogin = () => {
    navigate(`/login?redirect=${encodeURIComponent(redirectUrl)}`);
  };

  const form = useSignUp({
    autoSignIn: false,
    onDone: () => {
      // DONE が返った場合は complete 画面に遷移せず直接ログインへ
      navigateToLogin();
    },
  });

  if (form.step === 'complete') {
    return (
      <SignUpComplete
        message="ログインしてご利用ください。"
        buttonLabel="ログインへ"
        onNavigate={navigateToLogin}
      />
    );
  }

  if (form.step === 'confirm') {
    return <ConfirmCodeForm {...form} onSubmit={form.handleConfirm} />;
  }

  return (
    <SignUpFormFields
      {...form}
      onSubmit={form.handleSignUp}
      title="アカウント作成"
      subtitle="ダウンロードページにアクセスするには登録が必要です"
      submitLabel="アカウントを作成"
      submittingLabel="アカウント作成中..."
      footer={
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-500">
            すでにアカウントをお持ちの方は
            <Link
              to={`/login?redirect=${encodeURIComponent(redirectUrl)}`}
              className="text-primary-400 hover:text-primary-300 transition-colors ml-1"
            >
              ログイン
            </Link>
          </p>
        </div>
      }
    />
  );
}
